



























import { Vue, Component, Prop } from 'vue-property-decorator';
import { List } from 'vant';
// import { getnewslist } from '@/api/commonApi';
import { http } from '@/utils/http';
Vue.use(List);
@Component
export default class NewsList extends Vue {
  @Prop() voteName!: string;

  loading = false;
  finished = false;
  page = 1;
  getNewsList: any[] = [];
  loadingStatus = true;
  getnewslist(voteName: string, page: number) {
    return http.get(
      `/vote/${this.voteName}/controller.php?enews=news-list&page=` + page,
    );
  }

  onLoad() {
    if (this.loadingStatus) {
      this.loadingStatus = false;
      setTimeout(() => {
        this.getnewslist(this.voteName, this.page).then((res) =>
          this.endNewsData(res),
        );
      }, 150);
    }
  }
  endNewsData(res: any) {
    if (res.msg === '暂无相关数据') {
      this.finished = true;
    } else {
      this.getNewsList = [...this.getNewsList, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = true;
  }
  newsListWindowHref(item: any) {
    window.location.href = item.targetUrl;
  }
}
